<div class="layout-topbar" [class.topbar-scrolled]="isScrolled">
  <div class="layout-topbar-logo-container">
    <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
      <i class="pi pi-bars"></i>
    </button>
    <a class="layout-topbar-logo" routerLink="/">
      <a href="/">
        <img
          ngSrc="../../../../../assets/images/oskaru/oskaru_net_logo_v2.png"
          width="600"
          height="117"
          class="oskaru-logo"
          alt="oskaru.net logo"
          priority
        >
      </a>
    </a>
  </div>

  <div class="layout-topbar-actions">
    @if (authService.isLoggedIn()) {
      <div class="layout-config-menu">
        <div class="relative">
          <p-button
            variant="text"
            severity="secondary"
            class=""
            pStyleClass="@next"
            enterFromClass="hidden"
            enterActiveClass="animate-scalein"
            leaveToClass="hidden"
            leaveActiveClass="animate-fadeout"
            [hideOnOutsideClick]="true"
          >
            {{ this.authService.currentUser?.username }}
            <p-avatar
              [label]="this.authService.currentUser?.getAvatarLetters()"
              shape="circle"
              styleClass="oskaru-gradient text-white"
            />
          </p-button>
          <app-user-panel/>
        </div>
      </div>
    } @else {
      <div class="flex items-center gap-2">
        <div class="hidden md:block">
          <app-theme-select-button [showLabel]="false"></app-theme-select-button>
        </div>

        <p-button
          id="loginBtn"
          [routerLink]="loginLink"
          label="Login"
          [text]="true"
          severity="secondary"
        />
      </div>
    }
  </div>
</div>
